import {createListenerMiddleware} from '@reduxjs/toolkit';
import store from '..';
import {changeApi} from './changeApi';
import {setSelectedReleases} from '../appState/appStateSlice';

export const selectedReleaseListener = createListenerMiddleware();

selectedReleaseListener.startListening({
  actionCreator: setSelectedReleases,
  effect: async (action, listenerApi) => {
    listenerApi.cancelActiveListeners();

    // if more releases have been selected. Go fetch the changes
    if (action.payload) {
      console.log(`Fetching Changes for Releases ${action.payload.join(', ')}`);
      store.dispatch(changeApi.endpoints.getChangesByRelease.initiate(action.payload, {forceRefetch: true}));
    }
  },
});
